import { TApplicationState } from '../../types/redux';

export const selectPageExtra = (state: TApplicationState) => {
  return state.analytics.extra;
};
